import { Box } from '@mui/material';
import { ArtifactCard } from './ArtifactCard';
import { Artifact, ArtifactCardVariant } from '../../../types/artifactsTypes';
import { UserInfo } from '../../../types/UserInfoTypes';

interface ArtifactCardGridProps {
  artifacts: Artifact[];
  variant: ArtifactCardVariant;
  onCardClick: (artifact: Artifact) => void;
  usersById: Record<string, UserInfo>;
}

export const ArtifactCardGrid = ({
  artifacts,
  variant,
  onCardClick,
  usersById,
}: ArtifactCardGridProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(316px, 1fr))',
        gap: 3,
        width: '100%',
      }}
    >
      {artifacts.map((artifact) => (
        <ArtifactCard
          key={artifact.id}
          artifact={artifact}
          variant={variant}
          onClick={() => onCardClick(artifact)}
          usersById={usersById}
        />
      ))}
    </Box>
  );
};
